/* eslint-disable no-magic-numbers */

import {
	dimensions,
	filesize
} from "widgets/forms/validators/Assets";
import { requiredAsset } from "social/validators/validators";
import {
	isProtocolOptionalURL,
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";

import {
	MAX_IMAGE_BYTES,
	MAX_LENGTH_LANDING_PAGE
} from "./consts";

export const validators = {
	image: [
		requiredAsset,
		filesize({ max: MAX_IMAGE_BYTES }),
		dimensions({ minWidth: 254, minHeight: 133 }),
	],
	landingPage: [
		requiredNotNull,
		isURL,
		maxLength(MAX_LENGTH_LANDING_PAGE),
	],
	displayLink: [isProtocolOptionalURL],
};
